import autobind from 'core-decorators/lib/autobind';
import React from 'react';
import { StyleSheet, css } from 'aphrodite';


@autobind
class CookiePopup extends React.Component {
  state = {
    display:false,
    delay:false,
  };


  hide(){
    this.setState({display:false});
    setTimeout(() => this.setState({ delay: false}), 600);
    var now = new Date();
    var time = now.getTime();
    time += 20000000000;
    now.setTime(time);
    document.cookie = 
    'agreeCookies=yes' + 
    '; expires=' + now.toUTCString() + 
    '; path=/';
  }

  componentDidMount(){
    if(document.cookie.replace(/(?:(?:^|.*;\s*)agreeCookies\s*=\s*([^;]*).*$)|^.*$/, "$1") === "yes"){
      this.setState({ delay: false});
    } else {
      
      setTimeout(() => this.setState({ delay: true, display:true}), 3000);
    }
  }


  render() {
  const displayState = this.state.display ? styles.displayON : styles.displayOFF;
    const displayOFFState = this.state.delay ? null : styles.displayOFFOFF;

    return (
      <div onClick={this.hide} className={css(styles.wrapperMain)}>
        <div onClick={this.hide} className={css(styles.wrapper, displayState, displayOFFState)}>
          <div className={css(styles.text)}>We use cookies <span aria-labelledby="cookies" aria-label="cookies" role="img">🍪</span> to provide the best experience. By continuing to use our website, you agree to our cookies policy.</div>
          <button className={css(styles.button)}>
            <img alt="Minimaa close" className={css(styles.close)} src="../../assets/icons/close.png" />
          </button>
        </div>
      </div>
    );
  }
}


const styles = StyleSheet.create({
  wrapperMain:{
    width:"100%",
    background:"#000",
  },
  wrapper:{
    margin:"0 auto",
    maxWidth:1280,
    color:"#fff",
    display:"flex",
    fontSize:13,
    
    alignItems:"center",
    justifyContent:"space-between",
    background:"#000",
    transition:"0.3s",
    width:"calc(100% - 200px)",
    '@media (max-width: 1550px)': {
      width:"calc(100% - 120px)",
    },
    '@media (max-width: 950px)': {
      width:"calc(100% - 60px)",
    },
    '@media (max-width: 500px)': {
      width:"calc(100% - 60px)",
    },
    '@media (max-width: 400px)': {
      width:"calc(100% - 40px)",
    },
  },
  displayON:{
    opacity:1,
    height:"auto",
    paddingTop:20,
    paddingBottom:20,
  },
  displayOFF:{
    opacity:0,
    height:0,
    paddingTop:0,
    paddingBottom:0,
  },
  displayOFFOFF:{
    display:"none",
  },
  button:{
    background:"transparent",
    border:0,
    outline:"none",
    color: "#000",
    textDecoration:"none",
    position: "relative",
    transition: "all .2s",
    cursor:"pointer",
    '@media (max-width: 780px)': {
      marginLeft:0,
      marginTop:7,
    },
    
  },
  close:{
    position:"relative",
    width:25,
    filter: "invert(1)",
    paddingLeft:20,
    cursor:"poiter",
    zIndex:1000,
    '@media (max-width: 410px)': {
      paddingLeft:10,
      width:20,
    },
  },
  text:{
    '@media (max-width: 570px)': {
      fontSize:10,
    },
  },
  
});

export default CookiePopup;
